import React, { Component } from "react";
import { connect } from "react-redux";
import Helmet from "react-helmet";

// Components
import BodyWrap from "../../utils/BodyWrap";
import ContentDiv from "../../utils/ContentDiv";
import GeneralLoader from "../../GeneralLoader";
import Searchbar from "../../utils/searchbar/Searchbar";
import SearchTrainingEducation from "./SearchTrainingEducation";

// State
import { getTranslations } from "../../../store/actions/translations";
import { getReviewerTrainingEducationSignups } from "../../../store/actions/user";

class TrainingEducation extends Component {
	static initialAction(store, props, translationKey = null) {
		const promises = [];
		const translationSections = ["training_education", "buttons"];

		if (translationKey === null) {
			translationKey = props.translationKey;
		}

		let resTranslations =
			store !== null
				? getTranslations([translationKey], translationSections, translationKey)
				: props.getTranslations([translationKey], translationSections, translationKey);
		promises.push(resTranslations);

		let resSignups =
			store !== null
				? getReviewerTrainingEducationSignups()
				: props.getReviewerTrainingEducationSignups();
		promises.push(resSignups);

		return promises;
	}

	componentWillMount() {
		// Grab translations if not already in store
		if (!this.props.translations.pages[this.props.translationKey]) {
			TrainingEducation.initialAction(null, this.props);
		}
	}

	render() {
		const { translationsLoading, translations } = this.props;

		// ===================================
		//	HELMET STUFF
		// ===================================
		let helmet = null;

		let title = "";
		if (this.props.siteInfo.site) {
			title += this.props.siteInfo.site.title;
		}
		if (!!translations.pages[this.props.translationKey]) {
			if (title !== "") title += " | ";
			title += translations.pages[this.props.translationKey].title;
		}

		// helmet = (
		// 	<Helmet>
		// 		<title>{title}</title>
		// 		<meta property="og:title" content={title} />
		// 		<meta property="og:description" content={title} />
		// 		<meta property="twitter:title" content={title} />
		// 	</Helmet>
		// );

		return (
			<BodyWrap>
				{/* {helmet} */}
				<main>
					<div className="page-content">
						<div className="section-row">
							{translationsLoading ? (
								<GeneralLoader />
							) : !!translations.pages[this.props.translationKey] ? (
								<ContentDiv>
									{translations.pages[this.props.translationKey].content}
								</ContentDiv>
							) : null}
						</div>

						{!translationsLoading && (
							<Searchbar
								placeholder={
									translations.sections.training_education.searchbar_placeholder
								}
								component={SearchTrainingEducation}
								searchEndpoint={"search/training-education"}
								basePath={null}
								userType="user"
							/>
						)}
					</div>
				</main>
			</BodyWrap>
		);
	}
}

const mapStateToProps = (state, props) => {
	return {
		siteInfo: state.siteInfo,
		translationsLoading:
			state.translations.isLoading[props.translationKey] === undefined
				? 1
				: state.translations.isLoading[props.translationKey],
		translations: state.translations.translations
	};
};

export default connect(
	mapStateToProps,
	{ getTranslations, getReviewerTrainingEducationSignups }
)(TrainingEducation);



// WEBPACK FOOTER //
// ./src/components/training/education/TrainingEducation.js